import React from 'react';

import { FormInstance } from 'antd';
import {
  Input,
  Select,
  Spinner,
} from 'UI';
import { Culture } from 'constants/interface';

import {
  FormContainer,
  BaseFormItem,
  RemoteSelectContent,
  RemoteSelectSpinnerContainer,
  SeedsInline,
  NotesInline,
} from './style';

export interface AddVarietyFormData {
  name: string
  seedConsumption: number
  notes?: string
}

interface AddFormProps {
  formHandler: FormInstance
  onSubmit(data: unknown): void
  isLoading?: boolean
  onCultureSearch(search: string): void
  onCultureSelect(cultureId: string): void
  cultures: Culture[]
  isLoadingCultures: boolean
  addCultureForm: JSX.Element
}

const AddForm = ({
  formHandler,
  onSubmit,
  isLoading,
  onCultureSearch,
  onCultureSelect,
  cultures,
  isLoadingCultures,
  addCultureForm,
}: AddFormProps): JSX.Element => (
  <FormContainer
    layout="vertical"
    form={formHandler}
    requiredMark={false}
    onFinish={onSubmit as (val: unknown) => void}
  >
    <BaseFormItem
      label="Cultura"
      name="culture"
      rules={[
        {
          required: true,
          message: 'Nenhuma cultura selecionada',
        },
      ]}
    >
      <Select
        placeholder="Pesquisar cultura"
        disabled={isLoading}
        showArrow={false}
        showSearch
        onSearch={onCultureSearch}
        filterOption={false}
        onSelect={(cultureId) => onCultureSelect(cultureId)}
        // <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Sem resultados" />
        notFoundContent={<></>}
        dropdownRender={(menu) => (
          <div>
            <RemoteSelectContent>
              {menu}
              {isLoadingCultures && (
                <RemoteSelectSpinnerContainer>
                  <Spinner />
                </RemoteSelectSpinnerContainer>
              )}
            </RemoteSelectContent>
            {addCultureForm}
          </div>
        )}
      >
        {cultures.map((cultureOption) => (
          <Select.Option
            value={cultureOption.id}
            key={cultureOption.id}
          >
            {cultureOption.name}
          </Select.Option>
        ))}
      </Select>
    </BaseFormItem>
    <BaseFormItem
      label="Variedade"
      name="name"
      rules={[
        {
          required: true,
          message: 'Insira uma variedade',
        },
      ]}
    >
      <Input disabled={isLoading} />
    </BaseFormItem>
    <SeedsInline
      label="Sementes por célula"
      name="seedConsumption"
      initialValue={1}
    >
      <Select
        disabled={isLoading}
        // defaultValue={1}
        className="seed-consumption-input"
      >
        {[1, 2, 3, 4, 5].map((val) => (
          <Select.Option value={val} key={val}>
            {val}
          </Select.Option>
        ))}
      </Select>
    </SeedsInline>
    <NotesInline
      label="Observações"
      name="notes"
    >
      <Input.TextArea disabled={isLoading} rows={5} />
    </NotesInline>
    {/* <BaseFormItem
      label="Administrador"
      name="isAdmin"
      valuePropName="checked"
      initialValue={false}
    >
      <Switch disabled={isLoading} />
    </BaseFormItem>
    <BaseFormItem
      label="Ativo"
      name="isActive"
      valuePropName="checked"
      initialValue
    >
      <Switch disabled={isLoading} />
    </BaseFormItem> */}
  </FormContainer>
);

AddForm.defaultProps = {
  isLoading: false,
};

export default AddForm;
